namespace Matrix.Data {
    export class FxRateColumns {
        static columnsKey = 'Data.FxRate';
    }
}
